import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resResearch {
  success: boolean,
  message: string,
}

interface resGetAllResearch {
  success: boolean,
  message: string,
  result: [
    {
      RESEARCH_ID: string,
      RESEARCH_NAME: string,
      CONSENT: string,
      RESEARCH_DETAIL: string,
      RESEARCH_START: Date,
      RESEARCH_END: Date,
      ALWAYS_OPEN: string,
      RESEARCH_DOC: string,
      RESEARCH_IMG: string,
      COIN: number,
      VALUE: string,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      STATUS_RESEARCH: number,
      PROGRESS: {
        done: number,
        phase: number,
        sum_measureOfResearch: number,
        status_consent: boolean,
        status_sceen: boolean,
      }
    }
  ]
}

interface resGetConsentResearchById {
  success: boolean,
  message: string,
  result: [
    {
      RESEARCH_ID: string,
      RESEARCH_NAME: string,
      CONSENT: string,
      RESEARCH_DETAIL: string,
      RESEARCH_START: Date,
      RESEARCH_END: Date,
      ALWAYS_OPEN: string,
      RESEARCH_DOC: string,
      RESEARCH_IMG: string,
      COIN: number,
      VALUE: string,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      STATUS_RESEARCH: number,
      IS_LOGIN: boolean,
      PROGRESS: {
        done: number,
        phase: number,
        sum_measureOfResearch: number,
        status_consent: boolean,
        status_sceen: boolean,
      }
    }
  ]
}

interface resGetDetailResearchByMeasure {
  success: boolean,
  message: string,
  result: [
    {
      RESEARCH_ID: string,
      RESEARCH_NAME: string,
      CONSENT: string,
      RESEARCH_DETAIL: string,
      RESEARCH_START: Date,
      RESEARCH_END: Date,
      ALWAYS_OPEN: string,
      RESEARCH_DOC: string,
      RESEARCH_IMG: string,
      COIN: number,
      VALUE: string,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      STATUS_RESEARCH: number,
      DONE_SCEENQUESTION: boolean,
      SCEENQUESTION: [
        {
          type: string,
          question: string,
          choices: [
            {
              choices_id: number,
              choices_detail: string
            }
          ]
        },
      ],
      MEASURES: [
        {
          type: string,
          start: Date,
          end: Date,
          from_age: number,
          to_age: number,
          measures: [
            {
              measure_id: string,
              measure_name: string,
              query_measure: [
                {
                  MEASURE_ID: string,
                  MEASURE_NAME: string,
                  QUESTION: string,
                  STATUS_PUBLIC: string,
                  MEASURE_TYPE: string,
                  DESCRIPTION: string,
                  MEASURE_START: Date,
                  MEASURE_END: Date,
                  COIN: number,
                  SUGGESTION_COURSE: string,
                  TIME_MEASURE_AGAIN: number,
                  LINK: string,
                  FONT: string,
                  STATUS_MEASURE: number,
                  LANGUAGE: string,
                  ALWAYS_OPEN: boolean,
                  IS_VIEW: number,
                  CREATE_DATE: Date,
                  IMAGE_MEASURE: string,
                  IMAGE_ORIGANAL: string
                }
              ],
              DONE: boolean
            }
          ]
        }
      ],
      PROGRESS: {
        done: number,
        phase: number,
        sum_measureOfResearch: number,
        status_consent: boolean,
        status_sceen: boolean,
      }
    }
  ]
}

interface resGetDetailSceenQuestionResearchById {
  success: boolean,
  message: string,
  result: [
    {
      RESEARCH_ID: string,
      RESEARCH_NAME: string,
      CONSENT: string,
      RESEARCH_DETAIL: string,
      RESEARCH_START: Date,
      RESEARCH_END: Date,
      ALWAYS_OPEN: string,
      RESEARCH_DOC: string,
      RESEARCH_IMG: string,
      COIN: number,
      VALUE: string,
      CREATE_DATE: Date,
      UPDATE_DATE: Date,
      CREATE_BY: string,
      DOC_ORIGINAL: string,
      IMAGE_ORIGANAL: string,
      STATUS_RESEARCH: number,
      SCEENQUESTION: [
        {
          type: string,
          question: string,
          choices: [
            {
              choices_id: number,
              choices_detail: string
            }
          ]
        },
      ],
      PROGRESS: {
        done: number,
        phase: number,
        sum_measureOfResearch: number,
        status_consent: boolean,
        status_sceen: boolean,
      }
    }
  ]
}
interface resSendedAnswer {
  success: boolean,
  message: string,
  result:
  { status_done: boolean }
}



@Injectable({
  providedIn: 'root'
})

export class ResearchService {
  token: string = null;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getAllResearch() {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllResearch>(environment.URL + '/research/getAllResearch', { headers: headers });
  }

  getConsentResearchById(reid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetConsentResearchById>(environment.URL + '/research/getConsentResearchById?RESEARCH_ID=' + reid, { headers: headers });
  }

  approveConsentById(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resResearch>(environment.URL + '/research/approveConsentById', body, { headers: headers });
  }

  getlDetailResearchByMeasure(reid) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let body = {
      RESEARCH_ID: reid
    }

    return this.http.post<resGetDetailResearchByMeasure>(environment.URL + '/research/getlDetailResearchByMeasure', body, { headers: headers });
  }

  getDetailSceenQuestionResearchById(reid) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let body = {
      RESEARCH_ID: reid
    }

    return this.http.post<resGetDetailSceenQuestionResearchById>(environment.URL + '/research/getDetailSceenQuestionResearchById', body, { headers: headers });
  }

  sendAnswerSceenQuestion(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/research/sendAnswerSceenQuestion', body, { headers: headers });
  }

  sendAnswerOfResearch(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resSendedAnswer>(environment.URL + '/research/sendAnswerOfResearch', body, { headers: headers });
  }


}
